<template>
  <div class="InfoDeta">
    <div class="InfoDeta-background">
      <div class="cardnber-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        详情
      </div>
      <div class="InfoDeta-title">{{this.intitle}}</div>
      <div class="InfoDeta-content" v-html="this.incont"></div>
      <div class="InfoDeta-time">{{this.intime}}</div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      intitle: '',
      incont: '',
      intime: ''
    }
  },
  created () {
    // 接收信息中心传过来的信息详情
    this.intitle = this.$route.query.metitle;
    this.incont = this.$route.query.mecont;
    this.intime = this.$route.query.metime;
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/InfoDeta.css";
</style>